export const DASHBOARD_PERMISSION_RESOURCE = 'vault:dashboard';

export const DASHBOARD_NS = 'module.vaultDashboard';

/** PRD §14.2: the charts default to the last 30 days. The BFF and the engine take 1–90. */
export const SERIES_DAYS = 30;

/** The NAV chart draws this many vaults by TVL (R's n3); the selector adds the rest. */
export const TOP_VAULTS = 10;
